<template>
    <div>
        <h2>Deliveries dashboard</h2>
        <div class="card">
            <div class="card-body">
                <h5>Total deliveries: {{totalDeliveries}}</h5>
            </div>
        </div>
        <div class="mt-2 charts_container w-50">
            <ChartView  v-if="dashboard.trips.length"
                         :trips="dashboard.trips"
                         :updateFilter="onDashChange"
                         :filterValue="dashboard.filterTrips"
            ></ChartView>
        </div>
        <div class="mt-2">
            <TableView v-if="dashboard.trips.length"
                       :trips="filteredTrips"
                       :updateFilter="onDashChange"
                       :filterValue="dashboard.filterTrips"
            ></TableView>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import {INIT_DASHBORD, DASHBOARD_CHANGE} from "../../store/dashboard";
    import TableView from "./table_view";
    import ChartView from "./chart_view";
    import {isObject} from "../../utils/commons";
    import {formatTrip} from "../../utils/formatters";

    export default {
        name: "dashboard",
        components: {ChartView, TableView},
        computed: {
            totalDeliveries: function() {
                return this.dashboard.trips.length;
            },
            filteredTrips: function() {
                return this.dashboard.trips.filter(
                    trip => Object.keys(trip).some(
                        key => ((!isObject(trip[key]) && formatTrip(trip)[key]) || "").match(new RegExp(this.dashboard.filterTrips, "i"))
                    )
                )
            },
            ...mapState({
                dashboard: state => state.dashboard,
            })
        },
        methods: {
            ...mapActions({
                initDashboard: INIT_DASHBORD,
                onDashChange: DASHBOARD_CHANGE,
            }),
            onChange(event) {
                this.onDashChange({name: event.target.name, value: event.target.value});
            }
        },
        mounted() {
            this.initDashboard();
        }
    }
</script>

<style scoped>
    @media (max-width: 480px) {
        div.charts_container {
            width: 100% !important;
        }
    }

</style>
